import React from "react";
import HomePage from "./components/HomePage";

const App = () => {
  return <HomePage />;
};

export default App;
